import { render, staticRenderFns } from "./buyer-info.vue?vue&type=template&id=1b472d7a"
import script from "./buyer-info.vue?vue&type=script&lang=js"
export * from "./buyer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports